var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-tips',{attrs:{"icon":"success","iconColor":"#18A05E","title":"账号注册成功！","smallTips":"请先激活您的帐号，以使用更多的功能服务","redirectUrl":"/user/bind-mobile"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2efc716e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/main/success/success.vue
// module id = null
// module chunks = 